import classnames from 'classnames';

import { ShowcaseProvider } from './context';
import FeatureCard from './FeatureCard';
import ShowcaseItems from './Items';
import ShowcaseNav from './Nav';

export default function Showcase({
  Component = FeatureCard,
  items,
  layout = 'horizontal',
}) {
  const [firstItem] = items;
  const horizontalLayout = layout === 'horizontal';

  return (
    <ShowcaseProvider defaultSection={firstItem}>
      <div
        className={classnames({
          '-mx-4 md:flex items-start': !horizontalLayout,
        })}
      >
        <ShowcaseNav items={items} horizontalLayout={horizontalLayout} />
        <div
          className={classnames('px-4', {
            'md:w-3/5': !horizontalLayout,
          })}
        >
          <ShowcaseItems Component={Component} items={items} />
        </div>
      </div>
    </ShowcaseProvider>
  );
}
